// AccionesCell.jsx
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ShareLocationIcon from '@mui/icons-material/ShareLocation';
import ConnectingAirportsIcon from '@mui/icons-material/ConnectingAirports';
import FolderIcon from '@mui/icons-material/Folder';
import LoginIcon from '@mui/icons-material/Login';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';

// 👇 importa tu AuthContext
import { AuthContext } from 'context/AuthContext';

function AccionesCell(props) {
  const {
    numeroOrdenCabecera,
    nombreEstado,
    onShowModalInfo,
    onShowModalEdit,
    refreshTable,
  } = props;

  const navigate = useNavigate();
  const { hasRole } = useContext(AuthContext);
  const isClient = hasRole('client');

  const handleDocumentosClick = () => {
    navigate(`/ordenes/documentos/${numeroOrdenCabecera}`);
  };

  const handleDTransbordosClick = () => {
    navigate(`/ordenes/embarques/${numeroOrdenCabecera}`);
  };

  const handleFinalizarClick = () => {
    Swal.fire({
      title: '¿Finalizar la orden?',
      text: '¿Estás seguro de que quieres finalizar esta orden?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, finalizar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(`${process.env.REACT_APP_SERVER_URL}/api/orders/${numeroOrdenCabecera}/`, { id_estado: 2 })
          .then(() => {
            Swal.fire('Orden finalizada', 'La orden ha sido finalizada con éxito.', 'success');
            refreshTable?.();
          })
          .catch(() => {
            Swal.fire('Error', 'Hubo un problema al finalizar la orden. Inténtalo de nuevo.', 'error');
          });
      }
    });
  };

  const handleAperturarClick = () => {
    Swal.fire({
      title: '¿Aperturar la orden?',
      text: '¿Estás seguro de que quieres aperturar esta orden?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, aperturar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(`${process.env.REACT_APP_SERVER_URL}/api/orders/${numeroOrdenCabecera}/`, { id_estado: 1 })
          .then(() => {
            Swal.fire('Orden aperturada', 'La orden ha sido aperturada con éxito.', 'success');
            refreshTable?.();
          })
          .catch(() => {
            Swal.fire('Error', 'Hubo un problema al aperturar la orden. Inténtalo de nuevo.', 'error');
          });
      }
    });
  };

  const handleEliminarClick = () => {
    Swal.fire({
      title: '¿Eliminar la orden?',
      text: 'Esta acción no se puede deshacer. ¿Estás seguro?',
      icon: 'error',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${process.env.REACT_APP_SERVER_URL}/api/orders/${numeroOrdenCabecera}/`, { data: { force: false } })
          .then(() => {
            Swal.fire('Orden eliminada', 'La orden ha sido eliminada con éxito.', 'success');
            refreshTable?.();
          })
          .catch(() => {
            Swal.fire(
              'Error',
              'La orden tiene embarques o documentos asociados. Elimínalos e inténtalo de nuevo.',
              'error'
            );
          });
      }
    });
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
      {/* Info (siempre visible) */}
      <IconButton
        aria-label="info"
        color="success"
        onClick={() => onShowModalInfo(numeroOrdenCabecera)}
      >
        <ShareLocationIcon />
      </IconButton>

      {/* Documentos (siempre visible) */}
      <IconButton
        aria-label="documentos"
        color="warning"
        onClick={handleDocumentosClick}
      >
        <FolderIcon />
      </IconButton>

      <IconButton
        aria-label="transbordos"
        color="primary"
        onClick={handleDTransbordosClick}
      >
        <ConnectingAirportsIcon />
      </IconButton>
      {!isClient && (
        <>

          {nombreEstado === 'APERTURADA' ? (
            <IconButton aria-label="finalizar" color="error" onClick={handleFinalizarClick}>
              <LoginIcon />
            </IconButton>
          ) : (
            <IconButton aria-label="aperturar" color="success" onClick={handleAperturarClick}>
              <LoginIcon />
            </IconButton>
          )}

          <IconButton
            aria-label="editar"
            color="info"
            onClick={() => onShowModalEdit(numeroOrdenCabecera)}
          >
            <EditIcon />
          </IconButton>

          <IconButton
            aria-label="eliminar"
            color="error"
            onClick={handleEliminarClick}
          >
            <DeleteIcon />
          </IconButton>
        </>
      )}
    </div>
  );
}

AccionesCell.propTypes = {
  numeroOrdenCabecera: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  nombreEstado: PropTypes.string,
  onShowModalInfo: PropTypes.func.isRequired,
  onShowModalEdit: PropTypes.func, // solo se usa para NO-clientes
  refreshTable: PropTypes.func,
};

export default AccionesCell;
